module.exports = __webpack_public_path__ + "img/warning.fe3e4676.svg";